import { cn } from '@/lib/utils';

export const toolbarSlotClassName =
  'pointer-events-none absolute inset-x-0 top-0 z-40 flex justify-center px-2.5 pt-2.5 max-sm:px-2 max-sm:pt-2';

export const toolbarSurfaceClassName = cn(
  'group pointer-events-auto flex w-[min(916px,100%)] min-w-0 items-center gap-2 rounded-[22px] border border-white/70 p-2 text-[#111827]',
  '[background-color:rgba(255,255,255,0.78)] [background-image:linear-gradient(90deg,rgba(255,61,174,0)_0%,rgba(255,61,174,0)_46%,rgba(255,116,193,0.2)_100%)]',
  'shadow-[0_10px_30px_rgba(15,23,42,0.12)] backdrop-blur-[18px] backdrop-saturate-[1.35] will-change-[transform,opacity]',
  'transition-[transform,opacity] duration-300 ease-in-out motion-reduce:transition-none',
  'data-[tone=dark]:border-white/15 data-[tone=dark]:text-white data-[tone=dark]:shadow-[0_10px_30px_rgba(0,0,0,0.28)]',
  'data-[tone=dark]:[background-color:rgba(17,24,39,0.78)]',
  'data-[tone=dark]:[background-image:linear-gradient(90deg,rgba(255,61,174,0)_0%,rgba(255,61,174,0)_46%,rgba(255,116,193,0.28)_100%)]',
  '[@media(prefers-reduced-transparency:reduce)]:!bg-white [@media(prefers-reduced-transparency:reduce)]:backdrop-blur-none',
  '[@media(prefers-reduced-transparency:reduce)]:data-[tone=dark]:!bg-[var(--reader-bg,#1f2937)]',
  'supports-[not((backdrop-filter:blur(1px))_or_(-webkit-backdrop-filter:blur(1px)))]:!bg-white',
  'supports-[not((backdrop-filter:blur(1px))_or_(-webkit-backdrop-filter:blur(1px)))]:backdrop-blur-none',
  'supports-[not((backdrop-filter:blur(1px))_or_(-webkit-backdrop-filter:blur(1px)))]:data-[tone=dark]:!bg-[var(--reader-bg,#1f2937)]',
  'contrast-more:border-2 contrast-more:border-current',
  'max-sm:gap-1 max-sm:rounded-[18px] max-sm:p-1.5',
);

export const toolbarActionsClassName = 'ml-auto flex shrink-0 items-center gap-1';

export const toolbarActionClassName = cn(
  'inline-flex h-10 shrink-0 items-center justify-center gap-1.5 rounded-xl bg-transparent px-3 text-[15px] font-medium leading-none text-inherit',
  'hover:bg-[rgba(17,24,39,0.06)] group-data-[tone=dark]:hover:bg-white/[0.08]',
  'max-sm:w-10 max-sm:px-0',
);

export const toolbarIconButtonClassName = cn(
  'inline-flex size-10 shrink-0 items-center justify-center rounded-xl bg-transparent text-inherit',
  'hover:bg-[rgba(17,24,39,0.06)] group-data-[tone=dark]:hover:bg-white/[0.08]',
);

export const toolbarCollectionPopoverClassName = cn(
  '!z-[10001] !border !border-[#e5e7eb] !bg-white !text-[#111827] !opacity-100 !backdrop-blur-none',
  'data-[tone=dark]:!border-white/[0.12] data-[tone=dark]:!bg-[#111827] data-[tone=dark]:!text-white',
);

export const toolbarAddTriggerClassName = 'inline-flex items-center gap-1.5';

export const toolbarDividerClassName = 'h-[22px] w-px shrink-0 bg-current opacity-20';
